import React, { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import Loading from 'core-system/Loading'
import MyCommutersView from 'features/Segments/MyCommuters/MyCommutersView'
import { useDispatch, useSelector } from 'react-redux'
import { AppState } from 'redux/config/store'
import styled from 'styled-components'
import { employeeActions } from 'redux/employee/employeeSlice'
import { employerActions } from 'redux/employer/employerSlice'
import WorksitesView from './worksites/WorksitesView'
import GroupsView from './groups/GroupsView'
import TagsView from './Tags/TagsView'
import SyncSettingsView from './syncSettings/SyncSettingsView'
import PayCadencePageView from 'features/PayCadence/PayCadencePageView'

const Container = styled.div`
  padding: 2rem;
`

const SegmentsView = React.memo(() => {
  const dispatch = useDispatch()

  const {
    segmentsMap,
    allEmployeeSegmentId,
    employeesDeclinedFlag,
    finchConnectLoading,
  } = useSelector((state: AppState) => state.employer)

  const [searchParams] = useSearchParams()
  const [activeTab, setActiveTab] = useState(
    searchParams.get('tab') === 'worksites' ? 1 : 0
  )

  useEffect(() => {
    if (employeesDeclinedFlag) {
      dispatch(employeeActions.refreshActiveRoster())
      dispatch(employerActions.toggleDeclineInactiveEmployeesFlag())
    }
  }, [employeesDeclinedFlag, dispatch])

  if (!allEmployeeSegmentId || !segmentsMap?.[allEmployeeSegmentId] || finchConnectLoading) {
    return <Loading fullPage />
  }

  const tabs = [
    { label: 'Commuters', value: 0 },
    { label: 'Worksites', value: 1 },
    { label: 'Groups', value: 2 },
    { label: 'Tags', value: 3 },
    { label: 'Sync Settings', value: 4 },
    { label: 'Pay Schedules', value: 5 },
  ]

  return (
    <Container>
      {activeTab === 0 && (
        <MyCommutersView
          activeSegment={segmentsMap[allEmployeeSegmentId]}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          allEmployeeSegmentId={allEmployeeSegmentId}
          tabs={tabs}
        />
      )}
      {activeTab === 1 && (
        <WorksitesView
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          tabs={tabs}
        />
      )}
      {activeTab === 2 && (
        <GroupsView
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          tabs={tabs}
        />
      )}
      {activeTab === 3 && (
        <TagsView
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          tabs={tabs}
        />
      )}
      {activeTab === 4 && (
        <SyncSettingsView
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          tabs={tabs}
        />
      )}
      {activeTab === 5 && (
        <PayCadencePageView
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          tabs={tabs}
        />
      )}
    </Container>
  )
})

if (process.env.NODE_ENV !== 'production') {
  SegmentsView.displayName = 'SegmentsView'
}

export default SegmentsView
